import { CompanyService } from '@company/company.service';
import { ActivatedRoute } from '@angular/router';
import { HttpErrorResponse } from '@angular/common/http';
import { Subscription } from 'rxjs';
import { ModuleService } from '@module/module.service';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { IErrorResponse, IModule, ITableauWorkbook } from '@interfaces';
import { ExceptionService } from '@base/exceptions.service';
import { EMPTY, getNumber, ROLES } from '@utils';
import { TableauService } from '@base/tableau/tableau.service';
import { ICompany } from '@base/company/company.structures';
import { AppService } from '@base/app.service';
import { take } from 'rxjs/operators';

@Component({
  selector: 'app-company-module',
  templateUrl: './company-module.component.html',
  styleUrls: ['./company-module.component.sass']
})
export class CompanyModuleComponent implements OnInit, OnDestroy {
  private subscriptions: Subscription[];
  private tableauWorkbooks: ITableauWorkbook[];

  currentModule: IModule = EMPTY;
  companies: ICompany[];
  modules: IModule[];
  moduleCompanies: ICompany[];
  filterItems = '';
  p1 = 1;

  constructor(
    private moduleService: ModuleService,
    private exceptionService: ExceptionService,
    private route: ActivatedRoute,
    private companyService: CompanyService,
    private tableauService: TableauService,
    private mainService: AppService,
  ) {
    this.tableauWorkbooks = [];
    this.modules = [];
    this.subscriptions = [];
    this.companies = [];
    this.moduleCompanies = [];

    const modsSubscription = this.moduleService.observeModules().subscribe(
      (modules: IModule[]) => {
        this.modules = modules;
        this.fetchModuleInfo();
      },
      (e: HttpErrorResponse) => {const err: IErrorResponse = this.exceptionService.errorHandling(e); }
    );

    const moduleSubscription = this.moduleService.observeCurrentModule().subscribe(
      (res: IModule) => {
        this.currentModule = res;
        // this.getModuleCompaniesInfo();
      },
      (err: HttpErrorResponse) => {const error: IErrorResponse = this.exceptionService.errorHandling(err); }
    );

    const modCompaniesSubscription = this.moduleService.observeCompanyModules().subscribe(
      (res: ICompany[]) => this.moduleCompanies = res,
      (err: HttpErrorResponse) => {const error: IErrorResponse = this.exceptionService.errorHandling(err); }
    );

    this.subscriptions = [...this.subscriptions, modCompaniesSubscription,
      modsSubscription, moduleSubscription,
    ];
  }

  ngOnInit() {
    this.fetchModuleInfo();
  }

  ngOnDestroy() {
    this.subscriptions.map((s: Subscription) => s.unsubscribe());
  }

  /**
   * Recupera las empresas que tienen activado el modulo de Reportes,
   * este metodo es util cuando se refresca la vista, no se ejecuta hasta que
   * se carguen las empresas en el state...
   */
  private getModuleCompaniesInfo() {
    const processInfo = (this.companies.length && this.moduleCompanies.length === 0 &&
      this.currentModule !== EMPTY);

    if (processInfo) {
      this.moduleService.getModuleCompanies(this.currentModule, this.companies);
    }
  }

  /**
   * Activa el modulo de reportes...
   * este metodo es util cuando se refresca la vista. no se ejecuta hasta que
   * se carguen los modulos en el state...
   */
  private fetchModuleInfo() {
    const validParams = (this.currentModule === EMPTY && this.moduleCompanies.length === 0 &&
      this.modules.length);

    if (validParams) {
      this.moduleService.notifyFetching(true);
      const moduleId = getNumber(this.route.snapshot.paramMap.get('id'));
      const module = this.modules.find((m: IModule) => m.id === moduleId);

      if (typeof module !== 'undefined') {
        let userId = 0;

        this.mainService.getCurrentUser().pipe(take(1))
          .subscribe((user) => userId = (user.role['code'] === ROLES.ANALYST) ? user.id : 0);
        const filterParams = {moduleId: module.id, userId: userId, };
        this.moduleService.setCurrentModule(module);
        this.moduleService.filterCompanies(filterParams).subscribe(
          (companies: ICompany[]) => {
            this.moduleService.setCompanies(companies);
            this.moduleService.notifyFetching(false);
          }
        );
      }
    }
  }

  private syncTableauWorkbooksIntoDB(tableauWorkbooks: ITableauWorkbook[]) {
    this.tableauWorkbooks = tableauWorkbooks;

    if (this.tableauWorkbooks && this.currentModule !== EMPTY) {
      this.moduleService.getModuleCompanies(this.currentModule, this.companies);
      this.moduleService.notifyFetching(false);
    }
  }

  private setActiveModule() {
    const moduleId = getNumber(this.route.snapshot.paramMap.get('id'));

    if ((this.modules.length > 0) && (moduleId > 0)) {
      const objIndex = this.modules.findIndex((m: IModule) => m.id === moduleId);

      if (objIndex >= 0) {
        const module = this.modules[objIndex];
        this.moduleService.setCurrentModule(module);
      }
    }
  }

  // private processTags(tags, auxCompanies) {
  //   const groupedTags = _.groupBy(tags, 'company_id');
  //   Array.from(Object.keys(groupedTags)).map((item: any) => {
  //     const co = auxCompanies.find((c: ICompany) => getNumber(c.id) === getNumber(item));
  //     co['tags'] = groupedTags[item];
  //   });
  // }

  // private setCompaniesTags() {
  //   if (this.companies.length) {
  //     const auxCompanies = [...this.companies];
  //     const companiesIds = auxCompanies.map((c: ICompany) => getNumber(c.id));

  //     this.companyService.refreshTags(companiesIds).subscribe(
  //       (tags: []) => {this.processTags(tags, auxCompanies); }
  //     );
  //   }
  // }
}
